export const getHomePageSchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'Tiny Texts',
	logo: 'https://tinytexts.co/_next/image?url=https%3A%2F%2Fi.imgur.com%2F6ioQ9rW.png&w=640&q=75',
	url: 'https://tinytexts.co/',
});

export const getCategorySchema = (category, messages = [], nextPage) => ({
	'@context': 'https://schema.org',
	'@type': 'CollectionPage',
	name: category?.name || 'Unknown Category',
	description:
		category?.description || 'Explore the latest messages and offers.',
	url: `https://tinytexts.co/categories/${category?.categoryId}`,

	hasPart: messages.slice(0, 10).map((message, i) => ({
		'@type': 'CreativeWork',
		name: message?.brand || 'Unknown Brand',
		position: i + 1,
	})),

	mainEntity: {
		'@type': 'ItemList',
		name: 'Messages List',
		itemListElement: messages.slice(0, 10).map((message, i) => ({
			'@type': 'ListItem',
			position: i + 1,
			item: {
				'@type': 'CreativeWork',
				name: message?.brand || 'Unknown Brand',
			},
		})),
	},

	...(nextPage
		? {
				hasPart: [
					{
						'@type': 'WebPage',
						name: `Category - Page ${nextPage}`,
						url: `https://tinytexts.co/categories/${category?.categoryId}?page=${nextPage}`,
					},
				],
		  }
		: {}),
});

export const getBrandsPageSchema = (brands = [], nextPage) => ({
	'@context': 'https://schema.org',
	'@type': 'CollectionPage',
	name: 'Brands Listing',
	description: 'Browse SMS promos and campaigns from hundreds of brands.',
	url: 'https://tinytexts.co/brands',
	hasPart: {
		'@type': 'ItemList',
		name: 'Brand List',
		itemListElement: Array.isArray(brands)
			? brands.slice(0, 10).map((brand, index) => ({
					'@type': 'ListItem',
					position: index + 1,
					item: {
						'@type': 'Organization',
						name: brand?.name || 'Unknown Brand',
						url: `https://tinytexts.co/brand/${brand?.brandId}`,
						logo: brand?.iconObjectName
							? `https://your-image-url.com/brand-icons/${brand?.iconObjectName}`
							: 'https://your-image-url.com/default-logo.svg',
					},
			  }))
			: [],
	},
	...(nextPage
		? {
				hasPart: {
					'@type': 'WebPage',
					name: `Brands Listing - Page ${nextPage}`,
					url: `https://tinytexts.co/brands?page=${nextPage}`,
				},
		  }
		: {}),
});

export const getSingleBrandSchema = (brand = {}, messages = [], nextPage) => ({
	'@context': 'https://schema.org',
	'@type': 'Brand',
	name: brand?.name || 'Unknown Brand',
	description: brand?.description || 'No description available.',
	url: brand?.websiteLink
		? `https://${brand.websiteLink}`
		: `https://tinytexts.co/brand/${brand?.brandId}`,
	logo: brand?.iconUrl || 'https://your-image-url.com/default-logo.svg',

	itemListElement: Array.isArray(messages)
		? messages.slice(0, 10).map((message) => ({
				'@type': 'ListItem',
				item: {
					'@type': 'Organization',
					name: message?.brand || 'Unknown Product',
				},
		  }))
		: [],

	mainEntityOfPage: {
		'@type': 'WebPage',
		'@id': `https://tinytexts.co/brand/${brand?.brandId}`,
	},

	...(nextPage && {
		url: `https://tinytexts.co/brand/${brand?.brandId}?page=${nextPage}`,
	}),
});

export const getPrivacySchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'Privacy',
	name: 'Tiny Texts',
	title: 'Privacy Policy',
	url: 'https://tinytexts.co/about/privacy',
});
export const getPolicySchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'Policy',
	name: 'Tiny Texts',
	title: 'Tiny Texts DMCA Takedown Policy',
	url: 'https://tinytexts.co/about/dmca-policy',
});
export const getTermsAndConditionSchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'Terms&Conditions',
	name: 'Tiny Texts',
	title: 'Terms & Conditions',
	url: 'https://tinytexts.co/about/terms-and-conditions',
});
export const getRequestSchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'DMCARequest',
	name: 'Tiny Texts',
	title: 'DMCA Request',
	url: 'https://tinytexts.co/about/dmca-request',
});
